module.exports = __webpack_public_path__ + "static/media/(LH)-Prata-03.208490dd.jpg";